import React from 'react';
import { Text } from 'components/Typography';
import { theme } from 'design';
import { centsToDollarsDisplay } from 'utils';
import Sidebar, { ISidebarNotification } from './components/Sidebar';
import { Content, RowItem } from './components/styles';

interface IUploadPaymentSummarySidebarProps {
  totals?: { gross: number; cash?: number };
  hasCash?: boolean;
  notifications?: ISidebarNotification[];
  continueDisabled?: boolean;
  dataCy?: string;
  onBack: () => void;
  onContinue: () => void;
}

const UploadPaymentSummarySidebar = ({ totals, hasCash, notifications, onBack, onContinue, continueDisabled = false, dataCy = 'upload-payment-summary-sidebar' }: IUploadPaymentSummarySidebarProps) => (
  <Sidebar
    title="Payment Summary"
    leftActionButton={{ label: 'Back', appearance: 'white', onClick: onBack }}
    rightActionButton={{ label: 'Continue', appearance: 'primary', disabled: continueDisabled, onClick: onContinue }}
    notifications={notifications}
    dataCy={dataCy}
  >
    <Content>
      <Text size="small" fontWeight="medium">
        Payment Details
      </Text>
      <RowItem data-cy={`${dataCy}-gross`}>
        <Text size="small" color={theme.color.neutral[500]} data-cy={`${dataCy}-gross-label`}>
          Amount (Gross)
        </Text>
        <Text size="small" data-cy={`${dataCy}-gross-value`}>
          {centsToDollarsDisplay(totals?.gross ?? 0)}
        </Text>
      </RowItem>
      {hasCash && (
        <RowItem data-cy={`${dataCy}-cash`}>
          <Text size="small" color={theme.color.neutral[500]} data-cy={`${dataCy}-cash-label`}>
            Cash
          </Text>
          <Text size="small" data-cy={`${dataCy}-cash-value`}>
            {centsToDollarsDisplay(totals?.cash ?? 0)}
          </Text>
        </RowItem>
      )}
    </Content>
  </Sidebar>
);

export default UploadPaymentSummarySidebar;
